import { useNavigate } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';

import { getJoinPageUrl } from '../../utils';
import { useContextEffect } from '../useBetterHooks';
import { useAuth } from '../useAuth';

// Checks if the user has access to the assignment
const useCheckAssignmentAccess = ({ assignmentData }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();
  useContextEffect({
    deps: [assignmentData],
    ctx: { assignmentData },
    cb: (ctx) => {
      if (ctx.assignmentData && ctx.assignmentData?.student !== user?.uid) {
        toast({
          title: 'Invalid Assignment URL!',
          status: 'error',
          isClosable: true
        });
        navigate(getJoinPageUrl());
      }
    }
  });
};

export default useCheckAssignmentAccess;
